import React from 'react'

export default function Hall() {
    return (
        <div>
            THis is halls part of quick info
        </div>
    )
}
